<template>
  <b-modal
    id="add-or-update-modal"
    :visible="isAddActive"
    centered
    hide-footer
    hide-header
    no-close-on-esc
    no-close-on-backdrop
    size="md"
    @hidden="resetForm"
    @hide="resetForm"
    @change="(val) => $emit('update:is-add-active', val)"
  >
    <template #default="{ hide }">
      <b-overlay :show="loading" class="px-2">
        <div class="d-flex justify-content-between align-items-center content-sidebar-header py-1" style="border-bottom: 1px solid #000000;">
          <h5 class="mb-0" style="font-weight: 400; font-size: 14px; line-height: 160%;">
            Fill in information 
          </h5>

          <feather-icon class="ml-1 cursor-pointer" icon="XIcon" size="16" @click="hide" />
        </div>

        <validation-observer
          #default="{ handleSubmit }"
          ref="update_modal_form"
        >
          <b-form class="my-1" @submit.prevent="handleSubmit(onCreate)" @reset.prevent="resetForm">
            <b-alert v-if="errorMessage" variant="danger" :show="true">
              <div class="alert-body font-small-2">
                <b-card-text class="mb-0">
                  {{ errorMessage }}
                </b-card-text>
              </div>
            </b-alert>
        
            <b-row>
              <b-col cols="12" md="12">
                <validation-provider #default="validationContext" name="Hospital Name" rules="required">
                  <b-form-group label-for="hospital-name">
                    <template #label>
                      <span>Hospital Name</span>
                    </template>

                    <validation-provider #default="{ errors }" name="Hospital Name" vid="hospital-name" rules="required">
                      <div class="custom-input">
                        <b-form-input
                          id="hospital-name"
                          v-model="form_data.hospital_name"
                          placeholder="Enter the hospital name"
                        />
                      </div>
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>

                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <b-col cols="12" md="12">
                <validation-provider #default="validationContext" name="Hospital Location" rules="required">
                  <b-form-group label-for="hospital-location">
                    <template #label>
                      <span>Hospital Location</span>
                    </template>

                    <validation-provider #default="{ errors }" name="Hospital Location" vid="hospital-location" rules="required">
                      <div class="custom-input">
                        <b-form-input
                          id="hospital-location"
                          v-model="form_data.hospital_location"
                          placeholder="Enter the hospital location"
                        />
                      </div>
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>

                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <b-col cols="12" md="12">
                <validation-provider #default="validationContext" name="Referral Reason" rules="required">
                  <b-form-group label-for="referral-reason">
                    <template #label>
                      <span>Referral Reason</span>
                    </template>

                    <validation-provider #default="{ errors }" name="Referral Reason" vid="referral-reason" rules="required">
                      <div class="custom-input">
                        <b-form-textarea
                          id="referral-reason"
                          v-model="form_data.referral_reason"
                          placeholder="Enter your reason for this referral"
                        />
                      </div>
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>

                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
            </b-row>
  
            <!-- Form Actions -->
            <div class="d-flex mt-2">
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="outline-primary"
                class="mr-2"
                type="submit"
                :disabled="disableForm"
                @click="onCreate"
              >
                Proceed
              </b-button>

              <b-button
                v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                type="button"
                variant="outline-danger"
                @click="hide"
              >
                Cancel
              </b-button>
            </div>
          </b-form>
        </validation-observer>
      </b-overlay>
    </template>
  </b-modal>
</template>
      
<script>
import {
  BOverlay, BSidebar, BForm, BFormInput, BLink, 
  BFormTextarea, BFormInvalidFeedback, BButton, BFormSelect,
  BAlert, BCardText, BModal, BInputGroup, BFormGroup, BRow, BCol, BFormDatepicker, BDropdownItem,
} from 'bootstrap-vue'

import { required } from '@validations'
import { get, cloneDeep } from 'lodash';
import { ValidationProvider, ValidationObserver } from 'vee-validate'

import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import Cleave from 'vue-cleave-component';

import DieticianSelect from "@core/components/shared/admin/selects/DieticianSelect.vue"
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
import ImportDoctorSignatureModal from '@core/components/import-doctor-signature-modal/index.vue';
  
const rawData = {
  hospital_name: '',
  hospital_location: '',
  referral_reason: ''
}
      
export default {
  components: {
    BRow,
    BCol,
    BForm,
    BAlert,
    BModal,
    BButton,
    BLink,
    vSelect,
    BOverlay,
    BSidebar,
    BCardText,
    BFormInput,
    BFormSelect,
    BFormTextarea,
    BFormDatepicker,
    BFormInvalidFeedback,
    BDropdownItem,
    Cleave,
    BInputGroup,
    BFormGroup,
    // Form Validation
    ValidationProvider,
    ValidationObserver,

    DieticianSelect,
    ImportDoctorSignatureModal
  },
  directives: {
    Ripple,
  },
  model: {
    prop: 'isAddActive',
    event: 'update:is-add-active',
  },
  props: {
    resource: {
      type: String,
      required: true
    },
    isAddActive: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      required,
      loading: false,
      isImportFileActive: false,
      errorMessage: "",
      
      form_data: cloneDeep(rawData),
    }
  },
  computed: {
    disableForm(){
      return !this.form_data.hospital_name || !this.form_data.hospital_location || !this.can(`${this.resource}:CanAddNew`)
    },
  },
  methods: {
    async onCreate(){
      try {
        this.loading = true;
        this.errorMessage = "";
        const id = `${this.$route.params.id}`;

        if (!this.can(`${this.resource}:CanAddNew`)) {
          return
        }

        const { hospital_name, hospital_location, referral_reason } = this.form_data
        await this.useJwt().mainService.consultations.referToExternal(id, { hospital_name, hospital_location, referral_reason });

        this.$emit('update:is-add-active', false);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Success!',
            icon: 'CheckCircleIcon',
            variant: 'success',
            text: `Patient referred successfully`
          },
        });
      } catch (error) {
        const error_message = get(error, "response.data.message") || error.message
        this.errorMessage = error_message;

        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Error!',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
            text: error_message
          },
        });
      } finally {
        this.loading = false
        this.resetForm()
      }
    },
    resetForm() {
      this.form_data = cloneDeep(rawData);
      if (this.$refs.update_modal_form) {
        this.$refs.update_modal_form.reset()
      }
    },
  }
}
</script>
    
<style lang="scss">
  @import '@core/scss/vue/libs/vue-select.scss';
</style>
